export function sanitizeDownloadString(str) {
  const sanitizedStr = str
    .trim()
    .replace(/[\s/_]/g, "-") // replace spaces, underscores, and slashes with dashes
    .replace(/[^a-zA-Z0-9-]/g, "") // remove non-alphanumeric characters except dashes
    .replace(/-+/g, "-"); // collapse repeated dashes into a single dash

  return sanitizedStr;
}
